/* global fetch */
import cookies from 'browser-cookies';
import compose from 'async-deco/es2015/utils/compose';
import retry from 'async-deco/es2015/retry';
import deferUntilOnline from 'defer-until-online';

const serviceMarketingPublicRoot = '/api/marketing';
const checkCampaignsEndpoint = `${serviceMarketingPublicRoot}/multi-check`;
const ackCampaignEndpoint = `${serviceMarketingPublicRoot}/ack`;

const checkCampaigns = async (payload = {}) => {
  const uniqueId = cookies.get('__tesu');
  if (!uniqueId) throw new Error('Cannot find uniqueid (checkCampaigns)');

  let response;
  try {
    response = await fetch(checkCampaignsEndpoint, {
      body: JSON.stringify(payload),
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  } catch (e) {
    throw new Error('Checkcampaigns fetch Error'); // this normalise all the different error messages I am getting with fetch
  }

  if (response.ok) {
    return response.json();
  }

  console.log('MML: checkCampaigns: response not ok');
  throw new Error(`checkCampaigns: response not ok: ${response.status}`);
};

export const ackCampaign = deferUntilOnline()(async (campaignId) => {
  const uniqueId = cookies.get('__tesu');
  if (!uniqueId) throw new Error('Cannot find uniqueid (ackCampaign)');

  const ackUrl = `${ackCampaignEndpoint}/${campaignId}`;
  let response;
  try {
    response = await fetch(ackUrl, {
      method: 'DELETE',
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
        'Content-Type': 'application/json',
      },
    });
  } catch (e) {
    throw new Error('AckCampaign Fetch Error'); // this normalise all the different error messages I am getting with fetch
  }

  if (response.ok) {
    return;
  }
  console.log('MML: ackCampaign: response not ok');
  throw new Error(`ackCampaign: response not ok: ${response.status}`);
});

const RETRY_LIMIT = 2000;

const exponentialRetryToLimit = count => Math.min(RETRY_LIMIT, 250 * Math.pow(1.423, (count - 1)));

export const getCheckCampaignsWithRetry = ({ times, intervalBetweenRetry = exponentialRetryToLimit }) => {
  const checkCampaignDecorator = compose(
    retry({ times, interval: intervalBetweenRetry }),
    deferUntilOnline(),
  );
  return checkCampaignDecorator(checkCampaigns);
};
